const kategorie = [
	"Argrar allg.",
	"Befestigung allg.",
	"Bestattung allg.",
	"Kultanlage allg.",
	"Natur allg.",
	"Siedlung allg.",
	"Verkehr allg.",
	"unbekannt",
	"Einzelfund"
]

export default kategorie;
